import React from 'react'
import { connect } from 'react-redux';
import {
  LeftOutlined,
  RightOutlined
} from '@ant-design/icons';
import { IPagination } from '../../Utils/types';
import classes from './Pagination.module.scss';

interface StateProps { }
interface DispatchProps { }
interface Props extends StateProps, DispatchProps {
  paginationInfo: IPagination,
  handleChangePage: (page: number) => void
}

function Pagination(props: Props) {
  return (
    <div className={classes.Pagination}>
      <div>
        {
          props.paginationInfo.page > 1
          &&
          <LeftOutlined
            onClick={() => { props.handleChangePage(props.paginationInfo.page - 1) }}
          />
        }
      </div>
      <div>
        <span>{props.paginationInfo.page}</span>
      </div>
      <div>
        {
          props.paginationInfo.elsePages
          && <RightOutlined onClick={() => { props.handleChangePage(props.paginationInfo.page + 1) }} />
        }
      </div>
    </div>
  );
}

function mapStateToProps(state: any) {
  return {}
}
const mapDispatchToProps = {}

const ConnectedPagination = connect(mapStateToProps, mapDispatchToProps)(Pagination);
export { ConnectedPagination as Pagination };